import { DesignData, MediaText } from 'editor/src/store/design/types';

import { getSharedTextFieldMembers, SharedTextFieldMember } from './sharedTextFields';

/**
 * The member left behind when `leavingUuid` departs a shared group, where that
 * departure leaves exactly one.
 *
 * A group of one shares nothing, and leaving the id on the survivor dead ends
 * the panel: "Same value as" shows None because the partner is gone, while the
 * select stays closed telling the author to stop sharing first — which they
 * cannot, None already being what is selected. Every route out of a group owes
 * the survivor this: deletion (removeMediaElementOperation), unlinking
 * (updateSharedTextFieldOperation), and binding the layer to a code-set column.
 */
function dissolveLoneSharedTextField(
  designData: DesignData | undefined,
  element: MediaText,
  leavingUuid: number,
): SharedTextFieldMember | undefined {
  const { sharedFieldId } = element.extra;
  if (!sharedFieldId) {
    return undefined;
  }

  const survivors = getSharedTextFieldMembers(designData, sharedFieldId).filter(
    (member) => member.element.uuid !== leavingUuid,
  );

  return survivors.length === 1 ? survivors[0] : undefined;
}

export default dissolveLoneSharedTextField;
